module.exports = __webpack_public_path__ + "static/media/AdobeNaskh-Medium.f6e795ed.otf";